import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import type {
  GetVendorAccessByModuleResponseInterface,
  PostVendorAccessResponseInterface,
} from 'features/Enterprise/Payroll/types'

export const getVendorAccessByModule = (module: string) =>
  axiosInstanceApiGateway.Get<GetVendorAccessByModuleResponseInterface, true>({
    url: 'staff-management/internal/:version/staff-vendor-access',
    params: { module },
    version: 'v1',
    convertRequest: true,
  })

export const postVendorAccess = (data: { module: string; vendor_ids: number[] }) =>
  axiosInstanceApiGateway.Post<PostVendorAccessResponseInterface, true>({
    url: 'staff-management/internal/:version/staff-vendor-access',
    data,
    version: 'v1',
    convertRequest: true,
  })
